import { MyApprovalsTabController } from './my-approvals-tab.controller'

function myApprovalsTab () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/my-approvals-tab/my-approvals-tab-directive.html?$$REVISION$$',
    controller: MyApprovalsTabController,
    scope: {
      isTabSelected: '<',
      isFiltering: '=',
      tabCount: '='
    }
  }
}

export { myApprovalsTab }
